import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccAnalytics } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const WorkstationAnalytics: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccAnalytics(params);
  const a = data as Record<string, number>;

  return (
    <Card id="analytics" title="Analytics & KPIs" style={{ marginTop: 16 }} loading={isLoading}>
      <Row gutter={[16, 16]}>
        <Col xs={12} md={6}><Statistic title="Throughput (stages)" value={a?.throughput_stages_completed ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Utilization %" value={a?.utilization_percent ?? 0} suffix="%" /></Col>
        <Col xs={12} md={6}><Statistic title="Avg queue (proxy h)" value={a?.average_queue_time_hours ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Delayed ops" value={a?.average_delay_count ?? 0} /></Col>
        <Col xs={12} md={6}><Statistic title="Capacity efficiency %" value={a?.capacity_efficiency ?? 0} suffix="%" /></Col>
        <Col xs={12} md={6}><Statistic title="Inspection delay proxy" value={a?.inspection_delay_proxy ?? 0} /></Col>
      </Row>
    </Card>
  );
};

export default WorkstationAnalytics;
